export default "__VITE_ASSET__B5Qk04AA__"